import { initState as currencyBoard } from './currencyBoard/initState';
import { initState as currencyConverter } from './currencyConverter/initState';
import { initState as login } from './login/initState';
import { initState as mainBoard } from './mainBoard/initState';
import { initState as productManage } from './productManage/initState';
import { initState as register } from './register/initState';
import { initState as surveyManage } from './surveyManage/initState';
import { initState as worldClock } from './worldClock/initState';
import { initState as news } from './news/initState';
import { initState as eventSlider } from './eventSlider/initState';
export const organismInitStates = {
	//
	currencyBoard,
	eventSlider,
	currencyConverter,
	login,
	mainBoard,
	productManage,
	register,
	surveyManage,
	worldClock,
	news,
};
